import $ from 'jquery';

var shareEmailSection = document.querySelector('.share-email');

export function initContact() {
    $(function () {
        // Send contact
        $('.js-contact-form').on('submit', function (this: Element, e: Event) {
            e.preventDefault();
            const form = this as HTMLFormElement;
            if (form) {
                $('.js-failure-message').css('display', 'none');
                $('.js-success-message').css('display', 'none');
                $('.js-submit-button').css('display', 'none');
                $('.js-reload-button').css('display', 'none');
                $('.js-sending-message').css('display', 'flex');
                // call function for send contact
                const url = form.action;
                $.ajax({
                    url: url,
                    type: 'POST',
                    data: $(form).serialize(),
                    success: (data) => {
                        // close sections and hide modal (only one should happen)
                        $('.js-sending-message').css('display', 'none');
                        $('.js-required-fields-message').css('display', 'none');
                        $('.js-success-message').css('display', 'flex');
                        $('.js-reload-button').css('display', 'flex');
                        $('.form-holder-success').css('display', 'flex');
                        $('html,body').scrollTop(0);
                        if (shareEmailSection) {
                            shareEmailSection.classList.remove('open');
                        }
                    },
                    error: (jqXHR) => {
                        $('.js-submit-button').css('display', 'flex');
                        $('.js-sending-message').css('display', 'none');
                        const failureMsg = $('.js-failure-message');
                        failureMsg.html(jqXHR.responseText || jqXHR.statusText || 'Internal error');
                        failureMsg.css('display', 'flex');
                        $('html,body').scrollTop(0);
                    },
                });
            }
        });

        // reload (send another)
        $('.js-reload-button').on('click', function (e) {
            location.reload();
        });
    });
}
